import React from "react";

const GallerySection = () => {
  const galleryItems = [
    { title: "Urbania", image: "/images/gallery/1.jpeg" },
    { title: "Urbania", image: "/images/gallery/2.jpeg" },
    { title: "Urbania", image: "/images/gallery/3.jpeg" },
    { title: "Urbania", image: "/images/gallery/4.jpeg" },
    { title: "Urbania", image: "/images/gallery/5.jpeg" },
    { title: "Urbania", image: "/images/gallery/6.jpeg" },
    { title: "Urbania", image: "/images/gallery/7.jpeg" },
    { title: "Urbania", image: "/images/gallery/8.jpeg" },
    { title: "Urbania", image: "/images/gallery/9.jpeg" },
    { title: "Urbania", image: "/images/gallery/10.jpeg" },
    { title: "Urbania", image: "/images/gallery/11.jpeg" },
    { title: "Urbania", image: "/images/gallery/1.jpg" },
    { title: "Urbania", image: "/images/gallery/2.jpg" },
    { title: "Urbania", image: "/images/gallery/3.jpg" },
    { title: "Urbania", image: "/images/gallery/4.jpg" },
    { title: "Urbania", image: "/images/gallery/5.jpg" },
    { title: "Bus", image: "/images/gallery/6.jpg" },

  ];

  return (
    <>
      {/* Breadcrumb */}





<div
      className="breadcumb-wrapper"
      
      data-overlay="black"
      data-opacity="3"
    >
      <div className="container">
        <div className="breadcumb-content text-center">
          <h1 className="breadcumb-title">Gallery</h1>
        </div>
      </div>
    </div>



      {/* Gallery Start */}
      <section className="gauto-gallery-area section_70">
        <div className="container">
          <div className="row" id="lightgallery">

            {galleryItems.map((item, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4" data-src={item.image}>
                <div className="single-gallery bordered-card">
                  
                  <div className="img-holder">
                    <img className="gallery-img" src={item.image} alt={item.title} />

                    <div className="overlay-content">
                      <div className="inner-content">
                        <div className="title-box">
                          <h3><a href="#">{item.title}</a></h3>
                        </div>
                      </div>
                    </div>

                    <div className="link-zoom-button">
                      <div className="single-button">
                        <a href="#"><span className="fa fa-link"></span> Details</a>
                      </div>
                      <div className="single-button">
                        <a className="zoom lightbox-image" href={item.image}>
                          <span className="fa fa-search"></span> Zoom
                        </a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            ))}

          </div>
        </div>
      </section>
      {/* Gallery End */}
    </>
  );
};

export default GallerySection;
